import {Castable} from '@/app/utils/Castable';
import {Uuid} from '@/types/Types';

export abstract class BaseDTO extends Castable {

    public uuid: Uuid = null;

}
